/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of DIYActivityList
 * Alfapeople -Customisation object -For DIYActivityList page
 */

import React, { Component } from 'react';

export interface IToy {
  toyImage?: string;
  toyDescription?: string;
  toyLink?: string;
}
/**
 *
 * DIYActivityList component
 * @extends Component
 */
export class DIYActivityList extends Component {
  private readonly toys: IToy[] = [
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDvdA',
      toyDescription: 'no-sew doll carrier',
      toyLink: '/no-sew-doll-carrier',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDq1k',
      toyDescription: 'no-sew superhero cape',
      toyLink: '/no-sew-superhero-cape',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPe',
      toyDescription: 'LEGO photo frame',
      toyLink: '/lego-photo-frame',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqB',
      toyDescription: 'Monster Jam car wash',
      toyLink: '/monster-jam-car-wash',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAql',
      toyDescription: 'baby doll sleeping bag',
      toyLink: '/baby-doll-sleeping-bag',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDvdE',
      toyDescription: 'toy shadow tracing',
      toyLink: '/toy-shadow-tracing',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1B',
      toyDescription: 'crayon slime',
      toyLink: '/crayon-slime',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1D',
      toyDescription: 'dinosaur fossils',
      toyLink: '/dinosaur-fossils',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <h1 className='toy-heading'>diy activities</h1>
          </div>
          {this.toys.map((p) => (
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <div className='row product-row'>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='img-link'>
                    <img
                      className='img-responsive'
                      src={p.toyImage}
                      alt={p.toyDescription}
                    />
                  </a>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='toy-link'>
                    {p.toyDescription}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default DIYActivityList;
